module.exports = __webpack_public_path__ + "static/media/showdown_page.e739a6d6.PNG";